import { v4 } from 'uuid';
import { TableSettings } from '../TableSettings';
import { EntityType } from '../../comment';
import { translate } from '../../translation/Translator';

export const ContainerTableSettingsColumn = {
  identifier: 'identifier',
  stockLocation: 'stockLocation',
  bin: 'bin',
  parentContainer: 'parentContainer',
  containerType: 'containerType',
} as const;

export type ContainerTableSettingsColumn =
  (typeof ContainerTableSettingsColumn)[keyof typeof ContainerTableSettingsColumn];

export class ContainerTableSettings {
  static default(companyId: string) {
    return new TableSettings<ContainerTableSettingsColumn>({
      id: v4(),
      companyId,
      type: EntityType.container,
      columns: [
        {
          index: 0,
          column: ContainerTableSettingsColumn.identifier,
          label: translate({ key: ContainerTableSettingsColumn.identifier }),
        },
        {
          index: 1,
          column: ContainerTableSettingsColumn.stockLocation,
          label: translate({ key: ContainerTableSettingsColumn.stockLocation }),
        },
        {
          index: 2,
          column: ContainerTableSettingsColumn.bin,
          label: translate({ key: ContainerTableSettingsColumn.bin }),
        },
        {
          index: 3,
          column: ContainerTableSettingsColumn.parentContainer,
          label: translate({ key: ContainerTableSettingsColumn.parentContainer }),
        },
        {
          index: 4,
          column: ContainerTableSettingsColumn.containerType,
          label: translate({ key: ContainerTableSettingsColumn.containerType }),
        },
      ],
    });
  }
}
